import { render, staticRenderFns } from "./news.vue?vue&type=template&id=51f54591&scoped=true"
import script from "./news.vue?vue&type=script&lang=js"
export * from "./news.vue?vue&type=script&lang=js"
import style0 from "./news.vue?vue&type=style&index=0&id=51f54591&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/mobile/news.less?vue&type=style&index=1&id=51f54591&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f54591",
  null
  
)

export default component.exports